import React, { useEffect, useState } from "react";
import "./CorsairsPayOuttable.scss";

export default function CorsairsPayOuttable({ Game_Icons, onClose }) {
  const [imageArray, setImageArray] = useState([]);
  const [reversedPayouts, setReversedPayouts] = useState([]);
  const cellSize = 40;
  const rows = 3;
  const cols = 5;
  const activeColor = "#47a59c"; // 🔹 Aqua-blue
  const inactiveColor = "#070707b4"; // 🔹 Dark
  const lineColor = "#e6c408ff"; // line inside selected
  const paylines = [
    { id: 1, positions: [1, 1, 1, 1, 1] },      // Middle row
    { id: 2, positions: [0, 0, 0, 0, 0] },      // Top row
    { id: 3, positions: [2, 2, 2, 2, 2] },      // Bottom row
    { id: 4, positions: [0, 1, 2, 1, 0] },      // V shape
    { id: 5, positions: [2, 1, 0, 1, 2] },
    // Inverted V
    { id: 6, positions: [0, 0, 1, 0, 0] },      // Zigzag
    { id: 7, positions: [2, 2, 1, 2, 2] },      // Zigzag reverse
    { id: 8, positions: [1, 0, 0, 0, 1] },      // small peak
    { id: 9, positions: [1, 2, 2, 2, 1] },
  ];

  useEffect(() => {
    if (!Game_Icons || Object.keys(Game_Icons).length === 0) {
      console.warn("⚠️ No Game_Icons prop passed or it's empty!");
      setImageArray([]);
      return;
    }

    // ✅ Build image array safely
    const icons = Object.keys(Game_Icons).map((key, index) => ({
      id: index + 1,
      name: key,
      url: Game_Icons[key],
      title: `Icon ${index + 1}`,
      description: `Description for ${key}`,
    }));

    setImageArray(icons);

    // ✅ Setup payout map
    const kenoStakePayoutsMap = [
      { numMatches: 1, ratio: [0, 0, 0, 0, 0, 0, 0, 0, 0] },
      { numMatches: 2, ratio: [0, 0, 0, 0, 1, 2, 3, 5, 25] },
      { numMatches: 3, ratio: [5, 5, 10, 10, 20, 20, 30, 50, 250] },
      { numMatches: 4, ratio: [25, 25, 30, 30, 75, 100, 150, 500, 2500] },
      { numMatches: 5, ratio: [75, 75, 150, 150, 200, 400, 500, 1500, 5000] },
    ];

    setReversedPayouts([...kenoStakePayoutsMap].reverse());

    console.log("✅ imageArray:", icons);
  }, [Game_Icons]);

  // ✅ Safety check for rendering
  if (!Game_Icons || imageArray.length === 0) {
    return <p>No icons found.</p>;
  }

  return (
    <div className="main-CorsairsConatainer" >
      <button className="closebtn" onClick={onClose}>
        x
      </button>
      <div className="posn_top">
        <h1 className="Main_head">BIG BASS TREASURE PAYOUT TABLE</h1>
        <div className="FramePYCT">
          <div className="header_title"></div>

          <div className="Container-sub">
            <div className="Container-sub-sub">
              <table className="table_CTP"
                border="1"
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  marginTop: "50px",
                }}
              >
                <thead>
                  <tr>
                    <td style={{ width: "120px", height: "120px" }}></td>
                    {imageArray.slice(0, 8).map((item, index) => (
                      <th key={item.id}>
                        <img
                          src={item.url}
                          alt={item.name}
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                          }}
                        />
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {reversedPayouts.map((row, index) => (
                    <tr key={index}>
                      <td className="Icon_PayoutTblCT">
                        {row.numMatches}
                      </td>

                      {row.ratio.slice(0, 8).map((val, i) => (
                        <td
                          className="Value_PayoutTblCT"
                          key={i}
                        >
                          {val}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="middle-conatiner">
                All wins pay left to right except scattered wins. Only one highest
                win is paid on each payline. Payline wins are multiplied by the
                amount stake per line.
              </div>

              {/* ✅ Bonus Section */}
              <div className="bonusSection">
                {/* Bonus Wheel Card */}
                {imageArray[9] && (
                  <div className="bonusCard">
                    <img
                      src={imageArray[9].url}
                      className="bonusTitle"
                      alt="Bonus Symbol"
                    />
                    <div className="secondColumn">
                      <div className="wheelIcon">BONUS</div>
                      <div className="bonusText">
                        Three or more symbols on any active payline triggers the
                        bonus wheel. Wins are multiplied by the stake per line and
                        number of lines where bonus combination appears.
                      </div>
                    </div>
                  </div>
                )}

                {/* Wild Card */}
                {imageArray[8] && (
                  <div className="bonusCard">
                    <img
                      src={imageArray[8].url}
                      className="bonusTitle"
                      alt="Wild Symbol"
                    />
                    <div className="secondColumn">
                      <div className="wildIcon">WILD</div>
                      <div className="bonusText">
                        Wild substitutes for all symbols except bonus ones.
                        <div className="wildPays">
                          <div>
                            5 - 5000
                            <br />
                            4 - 2500
                            <br />
                            3 - 250
                            <br />
                            2 - 25
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="FramePYCT marg_top">
          <h1 className="Main_head" >PAY LINES</h1>
          <p className="line_changesCT"></p>
          <div className="paylines-gridCT">
            {paylines.map((line) => {
              const points = line.positions
                .map((row, col) => {
                  const x = col * cellSize + cellSize / 2;
                  const y = row * cellSize + cellSize / 2;
                  return `${x},${y}`;
                })
                .join(" ");

              return (
                <div key={line.id} className="line-boxCT">
                  <div className="line-numCT">{line.id}</div>
                  <svg
                    width={cellSize * cols}
                    height={cellSize * rows}
                    className="payline-svgCT"
                  >
                    {/* Draw background grid */}
                    {[...Array(rows)].map((_, r) =>
                      [...Array(cols)].map((_, c) => {
                        const isHighlighted = line.positions[c] === r;
                        return (
                          <rect
                            key={`${r}-${c}`}
                            x={c * cellSize}
                            y={r * cellSize}
                            width={cellSize}
                            height={cellSize}
                            fill={isHighlighted ? activeColor : inactiveColor}
                            stroke="#333"
                            strokeWidth="1"
                          />
                        );
                      })
                    )}

                    {/* Draw line through selected cells */}
                    <polyline
                      points={points}
                      fill="none"
                      stroke={lineColor}
                      strokeWidth="4"  // 🔹 bold like Hawaiian Waves
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />

                    {/* Draw dots on path */}
                    {line.positions.map((row, col) => (
                      <circle
                        key={col}
                        cx={col * cellSize + cellSize / 2}
                        cy={row * cellSize + cellSize / 2}
                        r="2"
                        fill="#470461c7"
                        stroke={lineColor}
                        strokeWidth="1"
                      />
                    ))}
                  </svg>
                </div>
              );
            })}
          </div>


        </div>
      </div>

    </div>
  );
}
